import { map, size } from "lodash";
import React from "react";
import { Grid } from "@mui/material";

import Input from "../ReadOnlyInput";
import {
  formatMonetary,
  formatPercentage,
  formatUpperCase,
} from "../../../../utils/formats";
import { Label, Separator } from "../styles";
import Table from "../../subcomponents/Table";

const justifyCenter = { justify: "center" };

const tipoPagamentoColumns = [
  { id: "codigoItemValor", name: "Item", style: justifyCenter },
  {
    id: "outrosValoresDescricao",
    name: "Outros valores",
    style: justifyCenter,
  },
  {
    id: "tipoPagamentoDescricao",
    name: "Tipo pagamento",
    style: justifyCenter,
  },
  {
    id: "valorAnterior",
    name: "Valor anterior",
    render: formatMonetary,
    style: justifyCenter,
  },
  { id: "codAvaliacao", name: "Avaliação", style: justifyCenter },
  {
    id: "situacaoOutrosValoresDescricao",
    name: "Situação outros valores",
    style: justifyCenter,
  },
];

const OperacaoSection = (props) => {
  const {
    proposalOperationLoading,
    orderSummaryLoading,
    paymentTypesLoading,

    numeroProposta,
    produto,
    pedidoOrcamento,
    valorProposta,
    cetAm,
    taxaMes,
    taxaReal,
    quantidadePrestacoes,
    retorno,
    valorPrestacao,
    spf,
    spm,
    paymentTypes,
    operationTotalValue,

    anotherOrderValues,
    anotherOrderValuesLoading,
  } = props;

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <Input
            loading={proposalOperationLoading}
            label="Número da proposta"
            value={numeroProposta}
          />
        </Grid>
        <Grid item xs={4}>
          <Input
            loading={proposalOperationLoading}
            label="Produto"
            value={formatUpperCase(produto)}
          />
        </Grid>
        <Grid item xs={4}>
          <Input
            loading={proposalOperationLoading}
            label="Pedido/Orçamento"
            value={pedidoOrcamento}
          />
        </Grid>
        <Grid item xs={4}>
          <Input
            loading={proposalOperationLoading}
            label="Valor da proposta"
            value={formatMonetary(valorProposta)}
          />
        </Grid>
        <Grid item xs={4}>
          <Input
            loading={proposalOperationLoading}
            label="CET a.m."
            value={formatPercentage(cetAm)}
          />
        </Grid>
        <Grid item xs={4}>
          <Input
            loading={proposalOperationLoading}
            label="Taxa mês/real"
            value={`${formatPercentage(taxaMes)} / ${formatPercentage(
              taxaReal
            )}`}
          />
        </Grid>
        <Grid item xs={4}>
          <Input
            loading={proposalOperationLoading}
            label="Condições"
            value={`${quantidadePrestacoes} X de ${formatMonetary(
              valorPrestacao
            )}`}
          />
        </Grid>
        <Grid item xs={4}>
          <Input
            loading={proposalOperationLoading}
            label="Retorno"
            value={formatUpperCase(retorno)}
          />
        </Grid>
        <Grid item xs={2}>
          <Input
            loading={orderSummaryLoading}
            label="SPF"
            value={!!spf ? "Sim" : "Não"}
          />
        </Grid>
        <Grid item xs={2}>
          <Input
            loading={orderSummaryLoading}
            label="SPM"
            value={!!spm ? "Sim" : "Não"}
          />
        </Grid>
      </Grid>

      <Separator />
      <Label marginBottom={30}>Forma de pagamento</Label>

      <Grid container>
        <Grid item xs={12}>
          {size(paymentTypes?.formasDePagamento) > 0 && (
            <Grid container spacing={1}>
              <Grid item xs={4}>
                <Label marginBottom={0}>Tipo parcela</Label>
              </Grid>
              <Grid item xs={3}>
                <Label marginBottom={0}>Valor total</Label>
              </Grid>
              <Grid item xs={2}>
                <Label marginBottom={0}>Quant. parcelas</Label>
              </Grid>
              <Grid item xs={3}>
                <Label marginBottom={0}>Parcela financeira</Label>
              </Grid>
            </Grid>
          )}
          <Grid item xs={12}>
            <Grid container spacing={1}>
              {map(paymentTypes?.formasDePagamento, (it) => {
                return (
                  <>
                    <Grid item xs={4} key={it.tipoParcelaId}>
                      <Input
                        loading={paymentTypesLoading}
                        value={formatUpperCase(it.tipoParcela)}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <Input
                        loading={paymentTypesLoading}
                        value={formatMonetary(it.valorTotal)}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <Input
                        loading={paymentTypesLoading}
                        value={it.qtdeParcelas}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <Input
                        loading={paymentTypesLoading}
                        value={formatMonetary(it.parcelaFinanceira)}
                      />
                    </Grid>
                  </>
                );
              })}
              <Grid item xs={4}>
                <Label height="100%" justify="flex-end" align="center">
                  Total da proposta (valor de venda):
                </Label>
              </Grid>
              <Grid item xs={3}>
                <Input
                  loading={proposalOperationLoading}
                  value={formatMonetary(operationTotalValue ?? 0)}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Separator />
      <Label marginBottom={30}>Tipo de pagamento</Label>

      <Grid container>
        <Grid item xs={12}>
          <Table
            loading={anotherOrderValuesLoading}
            noDataMessage="SEM DADOS."
            entries={anotherOrderValues}
            columns={tipoPagamentoColumns}
            loadingRows={2}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default OperacaoSection;
